import { emptyAutocompletePresets } from "../shared/presets/autocomplete.js";
import { emptyCardPresets } from "../shared/presets/card.js";
import { emptyLinearProgressPresets } from "../shared/presets/loadingIndicator.js";
import { MenuPresets } from "../shared/presets/menu.js";
import { ButtonTilePresets } from "./components/buttonTile.js";
import { CircularProgressPresets } from "./components/loadingIndicator.js";
import { TooltipPresets } from "./components/tooltip.js";
import { AccordionPresets } from "./presets/accordion.js";
import { AvatarPresets } from "./presets/avatar.js";
import { badgePresets } from "./presets/badge.js";
import { DataGridPresets } from "./presets/dataGrid.js";
import { DatePickerPresets } from "./presets/datePicker.js";
import { DividerPresets } from "./presets/divider.js";
import { FormControlPresets } from "./presets/formControl.js";
import { GridPresets } from "./presets/grid.js";
import { SideSheetPersets } from "./presets/sideSheet.js";
import { StatusIndicatorPresets } from "./presets/statusIndicator.js";
import { StepperPresets } from "./presets/stepper.js";
import { TablePresets } from "./presets/table.js";
export const getLensPresets = (tokens) => {
    const presets = {
        TooltipPresets: TooltipPresets(tokens),
        ButtonTilePresets: ButtonTilePresets,
        AccordionPresets: AccordionPresets(),
        AvatarPresets: AvatarPresets(tokens),
        StatusIndicatorPresets: StatusIndicatorPresets(),
        GridPresets: GridPresets(tokens),
        DatePickerPresets: DatePickerPresets(),
        FormControlPresets: FormControlPresets(tokens),
        DataGridPresets: DataGridPresets(tokens),
        DividerPresets: DividerPresets(),
        // unsupported components
        AutocompletePresets: emptyAutocompletePresets,
        StepperPresets: StepperPresets(),
        BadgePresets: badgePresets(tokens),
        CircularProgressPresets: CircularProgressPresets(tokens),
        LinearProgressPresets: emptyLinearProgressPresets,
        CardPresets: emptyCardPresets,
        MenuPresets: MenuPresets(),
        SideSheetPersets: SideSheetPersets(tokens),
        TablePresets: TablePresets(),
    };
    return presets;
};
//# sourceMappingURL=getLensPresets.js.map